module.exports = __webpack_public_path__ + "img/congratulations.9d35d181.png";